"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEEK_MS = exports.SECOND_MS = exports.MINUTE_MS = exports.HOUR_MS = exports.DAY_MS = void 0;
/** The number of milliseconds in 1 second */
const SECOND_MS = exports.SECOND_MS = 1000;
/** The number of milliseconds in 1 minute */
const MINUTE_MS = exports.MINUTE_MS = 60000;
/** The number of milliseconds in 1 hour */
const HOUR_MS = exports.HOUR_MS = 3600000;
/** The number of milliseconds in a 24-hour day. (Remember that days may sometimes have 23 or 25 hours.) */
const DAY_MS = exports.DAY_MS = 86400000;
/** The number of milliseconds in a typical week. (Remember that weeks may sometimes have 167 or 169 hours.) */
const WEEK_MS = exports.WEEK_MS = 604800000;